import React, { Fragment, memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getArrayFromMap,
  getCustomPanelQuestions,
  getResultFromMap,
  setResultObjectToMap,
} from 'src/components/JobCustomPanelBlock/utils';
import { JobCustomPanelBlockDefaultProps, JobCustomPanelBlockPropTypes } from 'src/components/JobCustomPanelBlock/propTypes';
import { QuestionRow } from 'src/components/JobDatasheet/QuestionRow';
import ChecklistStyles from 'src/components/JobChecklistForm/JobChecklistForm.styles';

const JobCustomPanelBlockComponent = ({ customPanel, customPanelResults, setCustomPanelResults, job }) => {
  const { t } = useTranslation();
  const [resultsMap, setResultsMap] = useState(new Map());
  const questions = getCustomPanelQuestions(customPanel);

  useEffect(() => {
    const returnMap = new Map();

    customPanelResults.forEach(result => setResultObjectToMap(returnMap, result));
    setResultsMap(returnMap);
  }, [customPanelResults]);

  const onChange = useCallback((question, key, value) => {
    const returnMap = new Map(resultsMap);
    returnMap.set(
      question.datasheetQuestionId,
      {
        currentQuestionId: question.datasheetQuestion.currentVersion.id,
        customPanelId: customPanel.id,
        customPanelVersionId: customPanel.currentVersion.id,
        result: JSON.stringify(value),
      }
    );
    setCustomPanelResults(getArrayFromMap(returnMap));
  }, [resultsMap]);

  return (
    <Fragment>
      <ChecklistStyles.BlockLabel>
        {t('CUSTOM_PANEL_BLOCK_TITLE', { name: customPanel.currentVersion.name })}
      </ChecklistStyles.BlockLabel>
      {questions.map(question => (
        <QuestionRow
          key={question.id}
          isFromCustomPanel
          job={job}
          question={question}
          result={getResultFromMap(resultsMap, question.datasheetQuestionId)}
          getResult={({ datasheetQuestionId }) => getResultFromMap(resultsMap, datasheetQuestionId)}
          allQuestions={questions}
          setResult={onChange}
        />
      ))}
    </Fragment>
  );
};

JobCustomPanelBlockComponent.propTypes = JobCustomPanelBlockPropTypes;
JobCustomPanelBlockComponent.defaultProps = JobCustomPanelBlockDefaultProps;

export const JobCustomPanelBlock = memo(JobCustomPanelBlockComponent);
